import { NgModule }     from '@angular/core';
import { CommonModule } from '@angular/common';

import { CanvasRectHitboxHoverDirective } from '@shared/canvas/canvas-rect-hitbox-hover.directive';
import { CanvasArcHitboxHoverDirective }  from './canvas-arc-hitbox-hover.directive';


@NgModule({
  declarations: [
    CanvasRectHitboxHoverDirective,
    CanvasArcHitboxHoverDirective
  ],
  imports:      [
    CommonModule
  ],
  exports:      [
    CanvasRectHitboxHoverDirective,
    CanvasArcHitboxHoverDirective
  ]
})
export class CanvasModule {}
